"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentInfoCommandToJSON = exports.PaymentInfoCommandFromJSONTyped = exports.PaymentInfoCommandFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function PaymentInfoCommandFromJSON(json) {
    return PaymentInfoCommandFromJSONTyped(json, false);
}
exports.PaymentInfoCommandFromJSON = PaymentInfoCommandFromJSON;
function PaymentInfoCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'creditCard': _1.CreditCardFromJSON(json['creditCard']),
        'promoCode': !runtime_1.exists(json, 'promoCode') ? undefined : json['promoCode'],
    };
}
exports.PaymentInfoCommandFromJSONTyped = PaymentInfoCommandFromJSONTyped;
function PaymentInfoCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'creditCard': _1.CreditCardToJSON(value.creditCard),
        'promoCode': value.promoCode,
    };
}
exports.PaymentInfoCommandToJSON = PaymentInfoCommandToJSON;
//# sourceMappingURL=PaymentInfoCommand.js.map